<template>

  <div class="app-container" v-if="canList">
    <div class="filter-container">
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="用户编号"
                v-model="listQuery.entity.user.code">
      </el-input>
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="用户名称"
                v-model="listQuery.entity.user.name">
      </el-input>
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="产生单号"
                v-model="listQuery.entity.coupon.fromOrderNo">
      </el-input>
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="使用单号"
                v-model="listQuery.entity.coupon.userOrderNo">
      </el-input>
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                placeholder="面值"-->
<!--                v-model="listQuery.entity.coupon.mount">-->
<!--      </el-input>-->
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="详情"
                v-model="listQuery.entity.coupon.info">
      </el-input>
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                placeholder="可使用产品"-->
<!--                v-model="listQuery.entity.coupon.goods">-->
<!--      </el-input>-->
      <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                 v-model="listQuery.entity.coupon.status"
                 placeholder="状态">
        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
        </el-option>
      </el-select>
      <el-date-picker
          @change='handleFilter'
          value-format="yyyy-MM-dd HH:mm:ss"
          class="filter-item input"
          v-model="listQuery.entity.coupon.createTimes"
          type="datetimerange"
          range-separator="至"
          start-placeholder="创建时间开始日期"
          end-placeholder="创建时间结束日期">
      </el-date-picker>
      <el-date-picker
          @change='handleFilter'
          value-format="yyyy-MM-dd HH:mm:ss"
          class="filter-item input"
          v-model="listQuery.entity.coupon.expireTimes"
          type="datetimerange"
          range-separator="至"
          start-placeholder="过期时间开始日期"
          end-placeholder="过期时间结束日期">
      </el-date-picker>

      <div style="display: inline-block">

        <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                   @click="handleFilter">查找
        </el-button>
        <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                   v-if="canSave" icon="el-icon-edit">添加
        </el-button>
<!--        <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"-->
<!--                   @click="handleDownload">导出-->
<!--        </el-button>-->
<!--        <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-upload2"-->
<!--                   @click="()=>$refs.file.click()">导入-->
<!--        </el-button>-->

        <input style="display: none" ref="file" @change="upload" type="file">
      </div>
    </div>

    <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
              style="width: 100%;">
      <yf-table-column align="center" label="ID">
        <template slot-scope="scope">
          <span>{{ scope.row.coupon.id }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="用户">
        <template slot-scope="scope">
          <span v-if="scope.row.coupon">{{ scope.row.user.name }}-{{ scope.row.user.code }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="产生单号">
        <template slot-scope="scope">
          <span v-if="scope.row.coupon">{{ scope.row.coupon.fromOrderNo }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="使用单号">
        <template slot-scope="scope">
          <span v-if="scope.row.coupon">{{ scope.row.coupon.userOrderNo }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="面值">
        <template slot-scope="scope">
          <span v-if="scope.row.coupon">{{ scope.row.coupon.mount }}</span>
        </template>
      </yf-table-column>
<!--      <yf-table-column align="center" label="详情">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.coupon">{{ scope.row.coupon.info }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
<!--      <yf-table-column align="center" label="可使用产品">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.coupon">{{ scope.row.coupon.goods }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
      <yf-table-column align="center" label="状态">
        <template slot-scope="scope">
                                                <span v-if="scope.row.coupon">

                         <el-tag :type="tagTypes[scope.row.coupon.status]"
                                 v-if="scope.row.coupon.status!=null">     {{ statusOptions[scope.row.coupon.status] }}</el-tag>

                        </span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="创建时间" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.coupon">{{ parseTime(scope.row.coupon.createTime) }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="过期时间" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.coupon">{{ parseTime(scope.row.coupon.expireTime) }}</span>
        </template>
      </yf-table-column>

      <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
          <el-button v-if="canSave" size="mini" type="danger"
                     @click="handleDelete(scope)">删除
          </el-button>
        </template>
      </yf-table-column>

    </el-table>

    <div class="pagination-container" style="margin-top: 20px">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
               style='width: 450px; margin-left:50px;'>
        <el-form-item label="用户编号" prop="coupon.userId">
          <el-input v-model="temp.user.code"></el-input>
        </el-form-item>
        <el-form-item label="产生单号" prop="coupon.fromOrderNo">
          <el-input v-model="temp.coupon.fromOrderNo"></el-input>
        </el-form-item>
<!--        <el-form-item label="使用单号" prop="coupon.userOrderNo">-->
<!--          <el-input v-model="temp.coupon.userOrderNo"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="面值" prop="coupon.mount">
          <el-input v-model="temp.coupon.mount"></el-input>
        </el-form-item>
        <el-form-item label="详情" prop="coupon.info">
          <el-input v-model="temp.coupon.info"></el-input>
        </el-form-item>
<!--        <el-form-item label="可使用产品" prop="coupon.goods">-->
<!--          <el-input v-model="temp.coupon.goods"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="状态" prop="coupon.status">
          <el-select class="filter-item" v-model="temp.coupon.status" placeholder="状态">
            <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                       :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" prop="coupon.createTime">
          <el-date-picker v-model="temp.coupon.createTime" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss" placeholder="创建时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="过期时间" prop="coupon.expireTime">
          <el-date-picker v-model="temp.coupon.expireTime" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss" placeholder="过期时间">
          </el-date-picker>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogForm">取消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
        <el-button v-else type="primary" @click="updateData">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style type="stylus">
.filter-container {
  /*padding-bottom: 20px;*/
}

.filter-item {
  margin-bottom: 10px;
}

.filter-item.input {
  /*line-height: 60px*/
  margin-right: 10px;
}
</style>

<script>
import {list, options, down, upload, info, save, update, remove} from '@/api/coupon'
import waves from '@/directive/waves' // 水波纹指令
import {downExcel} from '@/utils/down.js'
import {parseTime} from '@/utils'


import {mapGetters} from 'vuex'
import {hasAuth} from '@/utils/auth'

export default {
  name: 'test',
  directives: {
    waves
  },
  components: {},
  data() {
    return {
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      createTime: null
      ,
      expireTime: null
      ,
      listQuery: {
        page: 1,
        limit: 20,
        order: 'coupon.id desc',
        entity: {
          coupon:
              {
                id: null,
                userId: null,
                createTime: null,
                expireTime: null,
                fromOrderNo: null,
                userOrderNo: null,
                mount: null,
                info: null,
                goods: null,
                status: null
              }
          , user:
              {
                id: null,
                openId: null,
                unionId: null,
                avatar: null,
                mobile: null,
                name: null,
                code: null,
                tCode: null,
                rid: null,
                pid: null,
                team: null,
                levelId: null,
                time: null,
                status: null,
                password: null,
                remark: null,
                vip: null
              }
        }
      },
      statusOptions: [],
      tagTypes: ['info', '', 'warning', 'danger', 'warning'],
      temp: {

        coupon:
            {
              id: null,
              userId: null,
              createTime: null,
              expireTime: null,
              fromOrderNo: null,
              userOrderNo: null,
              mount: null,
              info: null,
              goods: null,
              status: null
            }
        , user:
            {
              id: null,
              openId: null,
              unionId: null,
              avatar: null,
              mobile: null,
              name: null,
              code: null,
              tCode: null,
              rid: null,
              pid: null,
              team: null,
              levelId: null,
              time: null,
              status: null,
              password: null,
              remark: null,
              vip: null
            }


      }
      ,
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      rules:
          {
            'coupon.userId': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'coupon.createTime': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'coupon.expireTime': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'coupon.fromOrderNo': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'coupon.userOrderNo': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'coupon.mount': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'coupon.info': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'coupon.goods': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'coupon.status': [
              {
                required: false,
                message: '必填字段',
                trigger: 'blur'
              }
            ]
          }
      ,
      downloadLoading: false,
      qData:
          {
            token: '',
            key: ''
          }
    }
  },
  created() {
    this.getList()
    this.getOptions()
  },
  computed: {
    ...mapGetters([
      'perms'
    ]),
    canSave() {
      return hasAuth(this.perms, 'coupon:save')
    },
    canDelete() {
      return hasAuth(this.perms, 'coupon:delete')
    },
    canUpdate() {
      return hasAuth(this.perms, 'coupon:update')
    },
    canList() {
      return hasAuth(this.perms, 'coupon:list')
    }
  },
  methods: {
    parseTime(time) {
      if (!time) return ''
      return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
    },
    getList() {
      this.listLoading = true
      list(this.listQuery).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    getOptions() {
      console.log('---<')
      options().then(res => {
        this.statusOptions = res.data.statusOptions
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      row.status = status
    },
    beforeFormShow(row) {
      this.resetTemp(row) // 更新数据
    },
    afterFormShow(row) {

    },
    beforeFormCommit() {

    },
    resetTemp(row) {
      this.temp = {
        coupon: {}
        , user: {}
      }
      if (row) {
        this.temp = Object.assign({}, row) // copy obj
      }

    },
    handleCreate() {
      this.beforeFormShow()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.afterFormShow()
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleDelete(scope) {
      this.index = scope.$index
      // this.beforeFormShow(scope.row)
      // this.temp = Object.assign({}, row) // copy obj
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
        this.deleteData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '删除失败'
        })
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()
              save(this.temp).then(res => {
                this.temp = res.data
                // this.list.unshift(this.temp)
                this.getList()
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '创建成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    deleteData() {
      // const ids = [this.temp.coupon.id]
      const ids = [this.list[this.index].coupon.id]
      remove({ids: ids}).then(res => {
        // 从当前队列中移除
        this.list.splice(this.index, 1)
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    handleUpdate(scope) {
      this.beforeFormShow(scope.row)
      info(scope.row.coupon.id).then(res => {
        this.temp = res.data
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()
              update(this.temp).then(() => {
                // this.list.splice(this.index, 1, this.temp)
                this.getList()
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '更新成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    closeDialogForm() {
      this.dialogFormVisible = false
    },
    upload(e) {
      upload(e.target.files[0]).then(res => {
        this.$notify({
          title: '成功',
          message: '上传成功!',
          type: 'success',
          duration: 2000
        })
        this.getList()
      })
    },
    handleDownload() {
      this.downloadLoading = true
      down(this.listQuery).then(res => {
        downExcel(res)
        this.downloadLoading = false
        this.$notify({
          title: '成功',
          message: '下载成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    // formatJson(filterVal, jsonData) {
    //     return jsonData.map(v => filterVal.map(j => {
    //         return v[j]
    //     }
    // ))
    // },
  }
}
</script>
